import Grid from "@mui/material/Unstable_Grid2";
import { Typography, Box } from "@mui/material";
import "./projects.css";

//Carousel
import Carousel from "react-bootstrap/Carousel";

//logo
import logo1 from "./assete/oil/logo1.png";
import logo2 from "./assete/oil/logo2.png";
import logo3 from "./assete/oil/logo3.png";
import logo4 from "./assete/oil/logo4.png";
import logo5 from "./assete/oil/logo5.png";
import logo6 from "./assete/oil/logo6.png";
import logo7 from "./assete/oil/logo7.png";

//photo

import pic1 from "./assete/oil/pic1.png";
import pic2 from "./assete/oil/pic2.png";
import pic3 from "./assete/oil/pic3.png";
import pic4 from "./assete/oil/pic4.png";
import pic5 from "./assete/oil/pic5.png";

const Oil = () => {
  return (
    <>
      <Grid container>
        <Grid xs={12}>
          <Box
            component="div"
            className="logo"
            sx={{
              display: "flex",

              justifyContent: "space-around",
              margin: "20px 0px",
            }}
          >
            <img src={logo1} alt="Logo" style={{ width: "10%" }}></img>
            <img src={logo2} alt="Logo" style={{ width: "10%" }}></img>
            <img src={logo3} alt="Logo" style={{ width: "10%" }}></img>
            <img src={logo4} alt="Logo" style={{ width: "10%" }}></img>
            <img src={logo5} alt="Logo" style={{ width: "10%" }}></img>
            <img src={logo6} alt="Logo" style={{ width: "12%" }}></img>
            <img src={logo7} alt="Logo" style={{ width: "10%" }}></img>
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={6}>
          <Box component="div" className="text" sx={{ marginTop: "20px" }}>
            <Typography variant="h5" sx={{ fontFamily: "Homa" }}>
              سیستم کنترل ، مانیتورینگ و ابزار دقیق
            </Typography>
            <ul
              style={{
                fontFamily: "Homa",
                marginTop: "15px",
                fontSize: "1.15rem",
              }}
            >
              <li>
                واحد{" "}
                <span style={{ fontFamily: "roboto", fontSize: "1rem" }}>
                  MTBE
                </span>{" "}
                پالایشگاه آبادان
              </li>
              <li>کارخانه پترو پالایش کوثر عجب شیر</li>
              <li>کارخانه پالایش نفت اسپادانا اشتهارد</li>
              <li>کارخانه تولید قیر آذر دوام یول تبریز</li>
              <li>کارخانه تولید قیر بهبود صنعت بیرجند</li>
              <li>کارخانه تولید قیر فخر آذربایجان جلفا</li>
              <li>واحد اکسترودر کارخانه پلی نار تبریز</li>
              <li>به روزرسانی آلارم واحد مولد های برق پالایشگاه تبریز</li>
            </ul>
            <Typography variant="h5" sx={{ fontFamily: "Homa" }}>
              سیستم مانیتورینگ و ثبت اطلاعات
            </Typography>
            <ul
              style={{
                fontFamily: "Homa",
                marginTop: "15px",
                fontSize: "1.15rem",
              }}
            >
              <li>مخزن 2053 پالایشگاه تبریز</li>
            </ul>
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={6}>
          <Box component="div" sx={{ marginTop: "20px" }}>
            <Carousel style={{ width: "100%", float: "left" }}>
              <Carousel.Item>
                <img src={pic2} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic1} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic3} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic4} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic5} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
            </Carousel>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
export default Oil;
